import { useEffect } from "react";
import {
  Routes,
  Route,
  useNavigationType,
  useLocation,
} from "react-router-dom";
import Nd from "./pages/Nd";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;
  const hash = location.hash;

  useEffect(() => {
    if (hash) {
      // Deep link such as "/#faq" — wait for the target section to mount.
      const id = hash.slice(1);
      const timeout = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 0);
      return () => clearTimeout(timeout);
    }
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname, hash]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "Closetrove — Transform your Closet Today";
        metaDescription =
          "Unlock the full potential of your wardrobe with Closetrove - your digital closet.";
        break;
      case "/privacy-policy":
        title = "Privacy Policy | Closetrove";
        metaDescription =
          "How Closetrove collects, uses, shares, and protects your personal information.";
        break;
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector(
        'head > meta[name="description"]'
      );
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Nd />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
  );
}
export default App;
